import Hero from "./Hero";
import AboutSection from "./Aboutsection";
import Servicessection from "./Servicessection";
import WhySection from "./Whysection";
import CoreValuesSection from './CoreValuesSection';
import Testimonials from "./Testimonials";

function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <Servicessection />
      <WhySection />
      <CoreValuesSection />;
      <Testimonials />
    </>
  );
}

export default Home;